module.exports = __webpack_public_path__ + "media/images/prevention_form/kaufsucht-88b7a3bd6637e28bc57f43de5a0f655f.svg";